<div class="p-3 flex-grow-1 overflow-auto">
    @if(arena()) {
    <h6 class="text-uppercase small fw-bold text-secondary mb-2">PLAYERS - {{ users().length }}
    </h6>

    <ul class="list-unstyled flex-grow-1 overflow-auto">
        @for(user of users(); track user.userId) {
        <app-player-panel [player]="user" [showModerator]="true"></app-player-panel>
        }
    </ul>
    }
</div>

@if(arena() && arena().hasVoice) {
<!--voice-controls-->
<div class="voice-controls-bar d-flex flex-column p-2 gap-2">
    <!-- Push to Talk button -->
    <button class="btn btn-ptt w-100 py-1" 
        (mousedown)="startPtt()" (mouseup)="stopPtt()" (mouseleave)="stopPtt()"
        (touchstart)="startPtt(); $event.preventDefault()" (touchend)="stopPtt()"
        [disabled]="isDeafened()"
        [class.active]="isPttActive()"
        title="Hold V or click and hold to talk">
        <i class="bi bi-mic-fill me-1"></i> Push to Talk (V)
    </button>
    <div class="d-flex justify-content-between align-items-center w-100">
        <button class="btn btn-icon rounded-circle" (click)="toggleMute()" [disabled]="isDeafened()"
            [title]="isDeafened() ? 'Muted by Deafen' : (isMuted() ? 'Unmute' : 'Mute')">
            @if (isMuted() || isDeafened()) {
            <i class="bi bi-mic-mute-fill"></i>
            } @else {
            <i class="bi bi-mic-fill"></i>
            }
        </button>
        <button class="btn btn-icon rounded-circle" (click)="toggleDeafen()" [class.deafened]="isDeafened()"
            [title]="isDeafened() ? 'Undeafen' : 'Deafen'" title="deafen">
            <i class="bi bi-headphones"></i>
        </button>
        <button class="btn btn-icon rounded-circle" (click)="goToSettings()"
            data-bs-toggle="modal" data-bs-target="#settingsModal" title="User Settings">
            <i class="bi bi-gear-fill"></i>
        </button>
    </div>
</div>
<audio id="audio" [hidden]="true" autoplay playsinline></audio>
<!--./voice-controls-->
}